import { render, staticRenderFns } from "./BetMatchDetailSlide.vue?vue&type=template&id=150510dc&scoped=true"
import script from "./BetMatchDetailSlide.vue?vue&type=script&lang=js"
export * from "./BetMatchDetailSlide.vue?vue&type=script&lang=js"
import style0 from "./BetMatchDetailSlide.vue?vue&type=style&index=0&id=150510dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150510dc",
  null
  
)

export default component.exports